import type { UserListItemTenantDto } from '@/features/superAdmin/features/users/types/superAdmin-users-dto';

export enum LoginPeriod {
    Daily,
    Weekly,
    Monthly,
    Quarterly,
    Yearly,
}

export enum UserActivityType {
    Registration,
    Login,
    ChangePassword,
    ForgotPassword,
}

export type UserActivityChartListPeriodResponseDto = {
    month: Date;
    value: number;
};

export type UserActivityChartResponseDto = {
    value: number;
    difference: number;
    periodValues?: UserActivityChartListPeriodResponseDto[];
};

export type UserActivityItemResponseDto = {
    date: Date;
    userId: string;
    userName: string | null;
    type: UserActivityType;
    assignedTenants?: UserListItemTenantDto[];
};

export type UserActivityListResponseDto = {
    items?: UserActivityItemResponseDto[];
    totalCount: number;
};
